import { render, staticRenderFns } from "./OrganizationAddress.vue?vue&type=template&id=52e4ab52&scoped=true&"
import script from "./OrganizationAddress.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAddress.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationAddress.vue?vue&type=style&index=0&id=52e4ab52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4ab52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e4ab52')) {
      api.createRecord('52e4ab52', component.options)
    } else {
      api.reload('52e4ab52', component.options)
    }
    module.hot.accept("./OrganizationAddress.vue?vue&type=template&id=52e4ab52&scoped=true&", function () {
      api.rerender('52e4ab52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/OrganizationAddress.vue"
export default component.exports